import { SuppliesTrackableProductDetailSchema } from "@redotech/redo-model/supplies/trackable-product";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getTrackableProducts = unaryRpc({
  name: "getTrackableProducts" as const,
  input: z.object({}),
  output: z.object({
    trackableProducts: z.array(SuppliesTrackableProductDetailSchema),
  }),
});
